<div class="noScroll" style="position: relative">
    <div class="search-bar">
        <div class="pull-right" style="padding: 10px" cdkDrag cdkDragRootElement=".cdk-overlay-pane">
            <div class="dlg-drag-handle" cdkDragHandle>
                <svg width="24px" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M10 9h4V6h3l-5-5-5 5h3v3zm-1 1H6V7l-5 5 5 5v-3h3v-4zm14 2l-5-5v3h-3v4h3v3l5-5zm-9 3h-4v3H7l5 5 5-5h-3v-3z"></path>
                    <path d="M0 0h24v24H0z" fill="none"></path>
                </svg>
            </div>
        </div>
    </div>
    <div class="noScroll" fxLayout="row" style="position: relative;">
        <div fxFlex="60px" fxLayout="column" style="margin-top: 25px;">
        </div>
        <div class="noScroll" fxFlex="100%" style="position: relative;">
            <img src="./assets/confetti.gif" style="position: absolute; left: -14px; top: -131px"/>
            <div style="position: relative; left: 20px" fxLayout="column" fxLayoutAlign="space-around center">
                <br/>
                <br/>
                <br/>
                <h1 style="font-size: 1.4em">{{'toast.greatNews2' | transloco}}</h1>
                <p style="font-size: 1.1em">{{'toast.latestVersion1' | transloco}}</p>
<!--                <p style="font-size: 1em">{{'toast.latestVersion2' | transloco}} {{version | json}}</p>-->
                <br>
                <br>
                <br>
                <button color="warn" mat-raised-button (click)="reload()">
                    <mat-icon>published_with_changes</mat-icon>
                    {{'toast.reloadBrowserNow' | transloco}}
                </button>
                <mat-divider style="padding: 20px;"></mat-divider>
                <br/>
                <mat-icon style="font-size: 7em; opacity: 0.1; position: relative; left: -35px">celebration</mat-icon>
            </div>
        </div>
    </div>
</div>
